<template>
    <img v-if="number === 1" src="/svg/smiley-poll/smiley-1.svg" alt="" />
    <img v-else-if="number === 2" src="/svg/smiley-poll/smiley-2.svg" alt="" />
    <img v-else-if="number === 3" src="/svg/smiley-poll/smiley-3.svg" alt="" />
    <img v-else-if="number === 4" src="/svg/smiley-poll/smiley-4.svg" alt="" />
    <div v-else-if="number === 0" class="bg-gray-300 rounded-full" alt="" />
</template>

<script>
export default {
    name: 'SmileyPollEmojiImage',
    props: {
        number: {
            required: true,
        },
    },
};
</script>
